import { render } from "./AllAgents.vue?vue&type=template&id=68a24890&scoped=true"
import script from "./AllAgents.vue?vue&type=script&lang=js"
export * from "./AllAgents.vue?vue&type=script&lang=js"

import "./AllAgents.vue?vue&type=style&index=0&id=68a24890&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68a24890"]])

export default __exports__